import { ReactNode } from 'react';
import cookie from 'cookie';
import { useAuth } from '../providers/Auth';
import { NextPageContext } from 'next';
import withConditionalRedirect from './withConditionalRedirect';

/**
 * Require the user to be authenticated in order to render the component.
 * If the user ISN'T authenticated, forward to {location} URL.
 */
export default function withAuth(WrappedComponent: ReactNode, location = '/session') {
    const clientCondition = () => {
        const { isAuthenticated } = useAuth();
        return !isAuthenticated;
    };

    const serverCondition = (ctx: NextPageContext) => {
        const { req } = ctx;
        if (req) {
            const cookies = cookie.parse(req.headers.cookie || '');
            return !cookies.access_token;
        }

        return false;
    };

    return withConditionalRedirect(WrappedComponent, location, clientCondition, serverCondition);
}
